/*
* Author   Jonathan Lurie - http://me.jonathanlurie.fr
* License  MIT
* Link      https://github.com/Pixpipe/pixpipejs
* Lab       MCIN - Montreal Neurological Institute
*/

import { Filter } from './Filter.js';
import { Image2D } from './Image2D.js';

/**
* ImageToImageFilter is not to be used as-is but rather as a base class for any
* filter that input a single Image2D and output a single Image2D.
* This class does not overload the update() method.
*/
class ImageToImageFilter extends Filter {

  constructor(){
    super();
  }


  /**
  * Check if all input image have the same size.
  * @return {Boolean} true is same size, false if not.
  */
  hasSameSizeInput(){
    var that = this;
    var inputCategories = Object.keys( this._input );
    var sameSize = true;

    var widths = [];
    var heights = [];

    inputCategories.forEach( function(key){
      widths.push( that._getInput( key ).getWidth() );
      heights.push( that._getInput( key ).getHeight() );
    });

    // if all input have the same size
    if(widths.length){
      widths.sort();
      heights.sort();
      sameSize = (widths[ 0 ] == widths[ widths.length -1 ] ) &&
                 (heights[ 0 ] == heights[ heights.length -1 ] );

      if( !sameSize ){
        console.warn("Input image do not all have the same size. Filter not valid");
      }
    }

    return sameSize;
  }


  /**
  * Check if all the inputs have the same number of component per pixel.
  * @return {Boolean} true if the ncpp are the same for all input image
  */
  hasSameNcppInput(){
    var inputCategories = Object.keys( this._input );

    // if no input, return false
    if(!inputCategories.length)
      return false;

    var ncpp = this._getInput( inputCategories[0] ).getComponentsPerPixel();

    for(var i=0; i<inputCategories.length; i++){
      if( ncpp != this._getInput( inputCategories[i] ).getComponentsPerPixel()){
        console.warn("Input image do not all have the same number of components per pixel. Filter not valid");
        return false;
      }
    }

    return true;
  }



} /* END class ImageToImageFilter */

export { ImageToImageFilter }
